import { ACKNOWLEDGE_LUX_PLUS_MONTH_FREE_PREVIEW_MODAL, API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS, CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION } from 'actions/actionConstants'
import { FETCH_LUX_PLUS_MEMBER_FREE_PREVIEW_ELIGIBILITY, FETCH_LUX_PLUS_PRODUCT_SUBSCRIPTION } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialLuxPlusState: App.LuxPlusState = {
  products: {
    subscription: {
      offers: undefined,
      fetching: false,
      error: undefined,
    },
    freePreview: {
      offer: undefined,
      fetching: false,
      error: undefined,
    },
  },
}

const apiCalls = apiReducerSwitch<App.LuxPlusState>({
  [FETCH_LUX_PLUS_PRODUCT_SUBSCRIPTION]: {
    request: (state) => ({
      products: {
        ...state.products,
        subscription: {
          fetching: true,
          error: undefined,
        },
      },
    }),
    success: (state, action) => ({
      products: {
        ...state.products,
        subscription: {
          offers: action.data,
          fetching: false,
          error: undefined,
        },
      },
    }),
    failure: (state, action) => ({
      products: {
        ...state.products,
        subscription: {
          fetching: false,
          error: action.error,
        },
      },
    }),
  },
  [FETCH_LUX_PLUS_MEMBER_FREE_PREVIEW_ELIGIBILITY]: {
    request: (state) => ({
      products: {
        ...state.products,
        freePreview: {
          fetching: true,
          error: undefined,
        },
      },
    }),
    success: (state, action) => ({
      products: {
        ...state.products,
        freePreview: {
          offer: action.data,
          fetching: false,
          error: undefined,
        },
      },
    }),
    failure: (state, action) => ({
      products: {
        ...state.products,
        freePreview: {
          fetching: false,
          error: action.error,
        },
      },
    }),
  },
})

export default createAppReducer<App.LuxPlusState>(initialLuxPlusState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [CLEAR_LUX_PLUS_MEMBER_SUBSCRIPTION]: (state, _action) => ({
    products: {
      ...state.products,
      freePreview: {
        ...initialLuxPlusState.products.freePreview,
      },
    },
  }),
  [ACKNOWLEDGE_LUX_PLUS_MONTH_FREE_PREVIEW_MODAL]: () => ({
    hasSeenLuxPlusMonthFreePreviewModal: true,
  })
})
